<template>
  <div class="view-wrapper view-wrapper-with-header">
    <van-nav-bar title="我的订单" left-arrow @click-left="$router.go(-1)" class="fixed-top" />
    <div>
      <van-tabs v-model="active" swipeable class="sticky-tabs">
        <van-tab title="全部" name="0">
          <van-pull-refresh
            v-model="orders.s0.pullLoading"
            @refresh="onPullRefresh(0)"
            class="pull-content"
          >
            <van-list
              v-model="orders.s0.loading"
              :finished="orders.s0.finished"
              finished-text="没有更多了"
              @load="onLoad(0)"
              class="order-list"
            >
              <OrderItem v-for="item in orders.s0.list" :key="item.OrderNo" :info="item"></OrderItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待付款" name="1">
          <van-pull-refresh
            v-model="orders.s1.pullLoading"
            @refresh="onPullRefresh(1)"
            class="pull-content"
          >
            <van-list
              v-model="orders.s1.loading"
              :finished="orders.s1.finished"
              finished-text="没有更多了"
              @load="onLoad(1)"
              class="order-list"
            >
              <OrderItem v-for="item in orders.s1.list" :key="item.OrderNo" :info="item"></OrderItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待发货" name="2">
          <van-pull-refresh
            v-model="orders.s2.pullLoading"
            @refresh="onPullRefresh(2)"
            class="pull-content"
          >
            <van-list
              v-model="orders.s2.loading"
              :finished="orders.s2.finished"
              finished-text="没有更多了"
              @load="onLoad(2)"
              class="order-list"
            >
              <OrderItem v-for="item in orders.s2.list" :key="item.OrderNo" :info="item"></OrderItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="已完成" name="5">
          <van-pull-refresh
            v-model="orders.s5.pullLoading"
            @refresh="onPullRefresh(5)"
            class="pull-content"
          >
            <van-list
              v-model="orders.s5.loading"
              :finished="orders.s5.finished"
              finished-text="没有更多了"
              @load="onLoad(5)"
              class="order-list"
            >
              <OrderItem v-for="item in orders.s5.list" :key="item.OrderNo" :info="item"></OrderItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import OrderItem from "@/components/OrderItem.vue";
export default {
  name: "order",
  components: {
    OrderItem
  },
  props: ["status"],
  data() {
    return {
      active: "",
      list: [],
      loading: false,
      finished: false,
      orders: {
        s0: {
          page: 1,
          size: 10,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false
        },
        s1: {
          page: 1,
          size: 10,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false
        },
        s2: {
          page: 1,
          size: 10,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false
        },
        s5: {
          page: 1,
          size: 10,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false
        }
      }
    };
  },
  created() {
    this.active = this.status;
  },
  activated() {
    //this.active = this.status;
    //console.log(this.$router);
    //this.loadOrders();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      //console.log(vm);
      if (from.name !== "orderView") {
        vm.active = vm.status;
      }
    });
  },
  methods: {
    loadOrders(status) {
      //let status = this.active;
      let statusOrders = this.orders["s" + status];
      //console.log(statusOrders);
      this.$ajax
        .get("/api/user/order", {
          params: {
            page: statusOrders.page,
            size: statusOrders.size,
            status: status
          }
        })
        .then(response => {
          //success
          statusOrders.loading = false;
          statusOrders.pullLoading = false;
          if (response.data.code === 1) {
            //console.log(response.data.data);
            let data = response.data.data;
            //没有了
            if (data.length === 0) {
              statusOrders.finished = true;
            }
            if (statusOrders.page === 1) {
              statusOrders.list = response.data.data;
            } else {
              statusOrders.list = statusOrders.list.concat(data);
            }
            statusOrders.page++;
            //statusOrders.finished = true;
          }
        });
    },
    onPullRefresh(status) {
      let statusOrders = this.orders["s" + status];
      statusOrders.page = 1;
      statusOrders.finished = false;
      this.loadOrders(status);
      //console.log("下拉");
    },
    onLoad(status) {
      let statusOrders = this.orders["s" + status];
      if (!statusOrders.pullLoading) {
        this.loadOrders(status);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pane-con {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
</style>